import utils from '../utils'
import api from '../apis'
const cacheKey = 'loginState';
export default {
    state: {
        loginState: utils.cache(cacheKey),
        ticket: {}
    },
    getters: {
        isLogin(state) {
            return state.loginState;
        },
        isSupply(state) {
            let supply = state.ticket && state.ticket.FeatureCodes && state.ticket.FeatureCodes.indexOf("business.supply")>-1;
            return supply;
            // if () {
            //     return false;
            // }
            // if (state.conferService.length === 0) {
            //     return true;
            // }
        },
        ticketInfo(state) {
            return state.ticket;
        }
    },
    mutations: {
        loginSucc(state) {
            state.loginState = true;
            utils.cache(cacheKey, true)
        },
        logoutSucc(state) {
            utils.cache(cacheKey, false)
            state.loginState = false;
            window.localStorage.removeItem('login_repair_info')
            state.ticket = {};
        },
        setTicketInfo(state, ticketInfo) {
            state.ticket = ticketInfo;
        }
    },
    actions: {
        logout({
            commit
        }) {
            return api.system.logout().then(function (response) {
                commit('logoutSucc')
                return response;
            }).catch(function () {
                commit('logoutSucc')
                return response;
            });
        },
        login({
            commit
        }, loginInfo) {
            return api.system.login(loginInfo).then(function (response) {
                if (response.data.isSucc) {
                    commit('setTicketInfo', response.data.result)
                    commit('loginSucc')
                }
                return response;
            });
        },
        loadTicketInfo({
            commit
        }, options) {
            return api.system.getTicketInfo(options).then(function (response) {
                if (response.data.isSucc) {
                    commit('setTicketInfo', response.data.result)
                }
                return response;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/ticketStore.js